var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.0004C8 20.1004 7.1 21.0004 6 21.0004C4.9 21.0004 4 20.1004 4 19.0004C4 17.9004 4.9 17.0004 6 17.0004C7.1 17.0004 8 17.9004 8 19.0004ZM16 17.0004C14.9 17.0004 14 17.9004 14 19.0004C14 20.1004 14.9 21.0004 16 21.0004C17.1 21.0004 18 20.1004 18 19.0004C18 17.9004 17.1 17.0004 16 17.0004ZM6.2 13.8004V13.7004L7.1 12.0004H14.5C15.2 12.0004 15.9 11.6004 16.2 11.0004L20.1 4.00039L18.4 3.00039L14.5 10.0004H7.5L3.3 1.00039H0V3.00039H2L5.6 10.6004L4.2 13.0004C4.1 13.3004 4 13.6004 4 14.0004C4 15.1004 4.9 16.0004 6 16.0004H18V14.0004H6.4C6.3 14.0004 6.2 13.9004 6.2 13.8004ZM17 1.80039L15.6 0.400391L10.8 5.20039L8.2 2.60039L6.8 4.00039L10.8 8.00039L17 1.80039Z",
    fill: "#19171B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.a832c6d1b1454ee8d19fd33d0ce912dc.svg";
export { ForwardRef as ReactComponent };